import { render, staticRenderFns } from "./NewIcreaText.vue?vue&type=template&id=350183d6&"
import script from "./NewIcreaText.vue?vue&type=script&lang=js&"
export * from "./NewIcreaText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports